import { render, staticRenderFns } from "./shopareas.vue?vue&type=template&id=47b2d556&"
import script from "./shopareas.vue?vue&type=script&lang=js&"
export * from "./shopareas.vue?vue&type=script&lang=js&"
import style0 from "./shopareas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports